<template>
  <div id="page-top">
    <main-nav type="index"></main-nav>

    <!-- 인사말 -->
    <section id="hello-section">
      <b-container>
        <div
          class="animate__animated animate__fadeIn animate__delay-1s lh-lg lead-in"
        >
          Hello!!
        </div>
        <div
          class="animate__animated animate__fadeInUp animate__delay-1s fw-bolder text"
        >
          어서오세요.<br />
          개발자 이재호 입니다.<br />
          만나서 반갑습니다.
        </div>
        <a
          v-scroll-to="'#introduce-section'"
          class="btn animate__animated animate__fadeInUp btn-to-next animate__delay-1s"
        >
          <fa-icon
            icon="arrow-alt-circle-down"
            class="animate__animated animate__heartBeat animate__infinite animate__delay-2s"
          ></fa-icon>
        </a>
      </b-container>
    </section>

    <!-- 간단 소개글 -->
    <section id="introduce-section">
      <b-container>
        <!-- useClassNames를 true로 설정하고 여기에 값을 넣으면 anchor가 닿았을 때 data-aos의 값을 class에 추가한다. -->
        <h2
          class="heading"
          data-aos="animate__flipInX animate__delay-1s"
          data-aos-anchor="#introduce-section"
        >
          Introduce
        </h2>
        <h3
          class="subheading"
          data-aos="animate__fadeInDown animate__delay-1s"
          data-aos-anchor="#introduce-section"
        >
          간단 소개
        </h3>
        <img
          class="rounded-circle"
          src="@/assets/images/me.jpg"
          alt="주인장 사진"
          data-aos="animate__fadeInDown animate__delay-1s"
          data-aos-anchor="#introduce-section"
        />
        <h4
          data-aos="animate__fadeInDown animate__delay-1s"
          data-aos-anchor="#introduce-section"
        >
          이재호 / Jaeho Lee
        </h4>
        <h5
          class="job"
          data-aos="animate__fadeInDown animate__delay-1s"
          data-aos-anchor="#introduce-section"
        >
          Developer
        </h5>
        <div
          data-aos="animate__fadeInDown animate__delay-1s"
          data-aos-anchor="#introduce-section"
        >
          WPF, Android, Spring, Vue.js, MariaDB<br />
          Master of Computer Engineering,
          <a href="https://www.inu.ac.kr" target="_blank">Incheon University</a
          >, 2017<br />
          <small>Bucheon, Republic of Korea</small>
        </div>

        <ul class="list-inline social-buttons">
          <li
            v-for="(item, index) in socialInfos"
            :key="item + index"
            class="list-inline-item"
            data-aos="animate__fadeInDown animate__delay-1s"
            data-aos-anchor="#introduce-section"
            :style="{
              '--animate-duration': '1.5s',
              '--animate-delay': 0.8 + 0.1 * index + 's',
            }"
          >
            <a :href="item.link" target="_blank" :title="item.title">
              <fa-icon v-if="item.icon" :icon="item.icon"></fa-icon>
              <div v-else>{{ item.text }}</div>
            </a>
          </li>
        </ul>
        <div
          data-aos="animate__fadeInDown animate__delay-1s"
          data-aos-anchor="#introduce-section"
        >
          이불속에서 게임하기, 음악듣기, 인방/애니메이션/영화 보기를 좋아하는
          개발자입니다.<br />
          안드로이드로 개발일을 시작하고 C# WPF를 거쳐 웹 개발자로 전향중입니다.
        </div>
      </b-container>
    </section>

    <!-- 포트폴리오 -->
    <section id="fortfolio-section">
      <b-container>
        <!-- useClassNames를 true로 설정하고 여기에 값을 넣으면 anchor가 닿았을 때 data-aos의 값을 class에 추가한다. -->
        <h2
          class="heading"
          data-aos="animate__flipInX animate__delay-1s"
          data-aos-anchor="#fortfolio-section"
        >
          fortfolio
        </h2>
        <h3
          class="subheading"
          data-aos="animate__fadeInDown animate__delay-1s"
          data-aos-anchor="#fortfolio-section"
        >
          주요 프로젝트
        </h3>
        <div class="project-list">
          <project-item class="project-item" :info="dobda" />
          <project-item class="project-item" :info="pickmeup" />
        </div>
      </b-container>
    </section>
  </div>
</template>

<script>
import AOS from 'aos';
import MainNav from '@/components/Navbar.vue';
import ProjectItem from '@/components/ProjectItem.vue';
import { dobda, pickmeup } from './data/project_data';

export default {
  name: 'Index',
  components: {
    'main-nav': MainNav,
    'project-item': ProjectItem,
  },
  data: function () {
    return {
      dobda,
      pickmeup,
    };
  },
  created() {
    AOS.init({
      once: true,
      useClassNames: true, // 이 값이 true일 때 data-aos에 클래스 이름들을 적용할 수 있다.
      initClassName: false,
      animatedClassName: 'animate__animated',
    });
  },
  computed: {
    socialInfos() {
      return [
        {
          title: 'GitLab',
          link: 'https://gitlab.com/kakaruu',
          icon: ['fab', 'gitlab'],
        },
        {
          title: 'Naver Blog',
          link: 'https://blog.naver.com/jhlee21071',
          icon: undefined,
          text: 'N',
        },
        {
          title: 'Facebook',
          link: 'https://www.facebook.com/profile.php?id=100003078219687',
          icon: ['fab', 'facebook-f'],
        },
        {
          title: 'Rocket Punch',
          link: 'https://www.rocketpunch.com/@jhlee21071',
          icon: 'rocket',
        },
        {
          title: '기술 이력서',
          link: 'https://gitlab.com/kakaruu/portfolio/-/blob/master/README.md',
          icon: 'portrait',
        },
        {
          title: 'Email',
          link: 'mailto:jhlee21071@gmail.com',
          icon: 'envelope',
        },
      ];
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Kaushan+Script&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,700');
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '~bootstrap-vue/dist/bootstrap-vue.min.css';
@import '~animate.css/animate.min.css';
@import '~aos/dist/aos.css';
@import '~@/assets/css/common.css';
</style>

<style scope>
section {
  padding: 100px 0;
}

section:nth-of-type(n + 2) {
  margin-top: 20px;
}

section .heading {
  font-size: 40px;
  margin-top: 15px;
  margin-bottom: 5px;
  text-transform: uppercase;
  --animate-duration: 1.5s;
  --animate-delay: 0.2s;
}

section .subheading {
  font-size: 25px;
  margin-bottom: 40px;
  text-transform: none;
  font-family: 'Noto Sans KR', Helvetica, sans-serif;
  --animate-duration: 1.5s;
  --animate-delay: 0.3s;
}

[data-aos] {
  visibility: hidden;
}

[data-aos].animate__animated {
  visibility: visible;
  pointer-events: auto;
}

@-webkit-keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 20px, 0);
    transform: translate3d(0, 20px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 20px, 0);
    transform: translate3d(0, 20px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes fadeInDown {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@media (min-width: 768px) {
  section {
    padding: 150px 0;
  }
}

/* hello-section 스타일 */
#hello-section {
  padding-top: 200px;
  padding-bottom: 200px;

  text-align: center;
  text-shadow: 1px 1px #40221155;
  color: #f2f2f2;

  background-image: url(~@/assets/images/hello.jpg);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center center;
  background-color: #3a1d1d44;
  background-blend-mode: overlay;

  /* 브라우저 호환성 */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -ms-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

#hello-section .container .lead-in {
  color: #bfa288;
  font-size: 30px;
  font-family: 'Kaushan Script', cursive, Helvetica, sans-serif;
  --animate-duration: 1.5s;
  --animate-delay: 0.5s;
}

#hello-section .container .text {
  font-size: 40px;
  --animate-duration: 1.5s;
  --animate-delay: 1s;
}

#hello-section .btn-to-next {
  margin-top: 100px;
  font-size: 50px;
  color: #bfa288;

  -webkit-transition: color 0.3s;
  -khtml-transition: color 0.3s;
  -moz-transition: color 0.3s;
  -ms-transition: color 0.3s;
  -o-transition: color 0.3s;
  transition: color 0.3s;

  --animate-duration: 1.5s;
  --animate-delay: 1.5s;
}

#hello-section .btn-to-next:focus,
#hello-section .btn-to-next:hover {
  color: #735645;
  outline: none;
  box-shadow: none;
}

@media (min-width: 768px) {
  #hello-section {
    padding-top: 250px;
    padding-bottom: 250px;
  }

  #hello-section .container .lead-in {
    font-size: 40px;
  }

  #hello-section .container .text {
    font-size: 50px;
  }
}

/* introduce-section 스타일 */
#introduce-section {
  text-align: center;
  font-weight: bold;

  color: #212121;

  background-image: url(~@/assets/images/introduce.jpg);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center center;
  background-color: #e9954b22;
  background-blend-mode: overlay;

  /* 브라우저 호환성 */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -ms-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

#introduce-section .container {
  background-color: #40221130;
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 30px;
}

#introduce-section img {
  width: 200px;
  height: 200px;
  margin-bottom: 15px;
  border: 4px solid #bfa28888;

  --animate-duration: 1.5s;
  --animate-delay: 0.4s;
}

#introduce-section h4 {
  font-family: Montserrat, Helvetica, sans-serif;
  font-size: 28px;

  --animate-duration: 1.5s;
  --animate-delay: 0.5s;
}

#introduce-section .job {
  font-size: 22px;
  margin-bottom: 15px;

  --animate-duration: 1.5s;
  --animate-delay: 0.6s;
}

#introduce-section .container > div:nth-of-type(1) {
  --animate-duration: 1.5s;
  --animate-delay: 0.7s;
}

#introduce-section .container > div:nth-of-type(2) {
  --animate-duration: 1.5s;
  --animate-delay: 1.4s;
}

#introduce-section .social-buttons {
  margin-top: 15px;
  margin-bottom: 25px;
}

#introduce-section a {
  color: #212121;
}

#introduce-section .social-buttons a {
  font-size: 20px;
  color: #f2f2f2;
  display: block;
  line-height: 40px;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: #212121;
  outline: 0;
}

/* introduce-section 스타일 */
#fortfolio-section {
  text-align: center;

  color: #212121;

  background: rgb(230, 216, 204);
  background: linear-gradient(
    0deg,
    rgba(230, 216, 204, 1) 0%,
    rgba(255, 255, 255, 1) 30%,
    rgba(255, 255, 255, 1) 70%,
    rgba(230, 216, 204, 1) 100%
  );
  background-blend-mode: overlay;
}

#fortfolio-section .container {
  background-color: #40221130;
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 20px;
}

#fortfolio-section .project-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100%, auto));
  row-gap: 10px;
  column-gap: 10px;
  /* 하위호환 */
  grid-row-gap: 10px;
  grid-column-gap: 10px;
}

@media (min-width: 768px) {
  #fortfolio-section .project-list {
    grid-template-columns: repeat(auto-fill, minmax(48%, auto));
  }
}

@media (min-width: 992px) {
  #fortfolio-section .project-list {
    grid-template-columns: repeat(auto-fill, minmax(32%, auto));
  }
}
</style>
